import { getLoggedInSession } from '@app/ACL/useLogin';
import {
	TApiTeamAppMember,
	TApiTeamAppMemberForm,
} from '@modules/TeamMembers/types';
import { ApiRequest } from '@zeal/zeal-lib';

import { ENDPOINTS } from '../endpoints';

export async function apiTeamApp({ queryKey: [,] }: any) {
	return new ApiRequest(ENDPOINTS.teamsMembers.teamApp.list)
		.addHeader('Accept', 'application/json')
		.GET<ApiResponseWithPagination<TApiTeamAppMember>>();
}

export async function apiAddTeam({ ...payload }: TApiTeamAppMemberForm) {
	const { authorization } = getLoggedInSession();

	const formData = new FormData();
	Object.keys(payload).forEach((k) => {
		const key = k as keyof TApiTeamAppMemberForm;
		if (key === 'photo') {
			const photo = payload[key]?.[0];
			if (photo instanceof File) {
				formData.append('photo', photo);
			}
		} else if (key !== 'uuid' && payload[key]) {
			formData.append(key, payload[key]);
		}
	});

	return new ApiRequest(ENDPOINTS.teamsMembers.teamApp.add)
		.addHeader('Authorization', authorization)
		.POST(formData, { noAuth: true });
}

export async function apiEditTeam({ ...payload }: TApiTeamAppMemberForm) {
	const { authorization } = getLoggedInSession();

	const formData = new FormData();
	Object.keys(payload).forEach((k) => {
		const key = k as keyof TApiTeamAppMemberForm;
		if (key === 'photo') {
			const photo = payload[key]?.[0];
			if (photo instanceof File) {
				formData.append('photo', photo);
			}
		} else if (key !== 'uuid' && payload[key]) {
			formData.append(key, payload[key]);
		}
	});

	formData.append('_method', 'PUT');
	return new ApiRequest(ENDPOINTS.teamsMembers.teamApp.edit(payload.uuid ?? ''))
		.addHeader('Authorization', authorization)
		.POST(formData, { noAuth: true });
}

export async function apiDeleteTeam({ ...payload }: { uuid: string }) {
	return new ApiRequest(
		ENDPOINTS.teamsMembers.teamApp.delete(payload.uuid ?? '')
	)
		.addHeader('Accept', 'application/json')
		.addHeader('Content-type', 'application/json')
		.DELETE('', { noAuth: true });
}
